import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import decodeJwt from 'jwt-decode';

import ServerUrl from './Constants/ServerUrl';
import isPresent from '../Common/Utils/Present';

const AuthProvider = (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const email = username;
    const request = new Request(ServerUrl + '/api/v3/authenticates', {
      method: 'POST',
      body: JSON.stringify({ auth: { email, password } }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    return fetch(request)
      .then(response => {
        if (response.status === 401) {
          return response.json().then(json => {
            if (isPresent(json.message)) {
              throw new Error(json.message);
            } else {
              throw new Error(response.statusText);
            }
          });
        } else if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ jwt }) => {
        const decoded_jwt = decodeJwt(jwt)
        const team = JSON.stringify(decoded_jwt.team);
        localStorage.setItem('token', jwt);
        localStorage.setItem('team', team);
        localStorage.setItem('user_id', decoded_jwt.sub);
      });
  } else if (type === AUTH_LOGOUT) {
    localStorage.removeItem('token');
    localStorage.removeItem('team');
    return Promise.resolve();
  } else if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401) {
      return Promise.reject();
    }
    return Promise.resolve();
  } else if (type === AUTH_CHECK) {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
  } else if (type === AUTH_GET_PERMISSIONS) {
    const team = JSON.parse(localStorage.getItem('team'));
    if (team === null) {
      return Promise.reject('Missing permissions');
    } else {
      return Promise.resolve(team);
    }
  }
  return Promise.reject('Unknown method');
};

export default AuthProvider;



// WEBPACK FOOTER //
// ./src/views/Framework/AuthProvider.tsx